import { DeliveryStatus, SalesOrderDTO, SalesOrderType } from 'core/api';

function canNavigateBetween(from: DeliveryStatus, to: DeliveryStatus): boolean {
	const transitions = {
		[DeliveryStatus.Rejected]: [] as DeliveryStatus[],
		[DeliveryStatus.New]: [DeliveryStatus.Accepted, DeliveryStatus.Preparing, DeliveryStatus.Prepared, DeliveryStatus.Delivering, DeliveryStatus.Delivered, DeliveryStatus.Rejected],
		[DeliveryStatus.Accepted]: [DeliveryStatus.Preparing, DeliveryStatus.Prepared, DeliveryStatus.Delivering, DeliveryStatus.Delivered, DeliveryStatus.Rejected],
		[DeliveryStatus.Preparing]: [DeliveryStatus.Prepared, DeliveryStatus.Delivering, DeliveryStatus.Delivered, DeliveryStatus.Rejected],
		[DeliveryStatus.Prepared]: [DeliveryStatus.Delivering, DeliveryStatus.Delivered, DeliveryStatus.Rejected],
		[DeliveryStatus.Delivering]: [DeliveryStatus.Delivered, DeliveryStatus.Rejected],
		[DeliveryStatus.Delivered]: [DeliveryStatus.Rejected],
	};
	return transitions[from] && transitions[from].includes(to);
}

export function canTransition(order: SalesOrderDTO, to: DeliveryStatus): boolean {
	if (to === DeliveryStatus.Rejected && order.IsFrozen)
		return false;

	if (to === DeliveryStatus.Delivering && order.Type !== SalesOrderType.Delivery)
		return false;

	return canNavigateBetween(order.DeliveryStatus, to);
}

export function canTransitionToAnyState(order: SalesOrderDTO): boolean {
	return canTransition(order, DeliveryStatus.Accepted) ||
		canTransition(order, DeliveryStatus.Rejected) ||
		canTransition(order, DeliveryStatus.Preparing) ||
		canTransition(order, DeliveryStatus.Prepared) ||
		canTransition(order, DeliveryStatus.Delivering) ||
		canTransition(order, DeliveryStatus.Delivered);
}

export const canTransitionToAccept = (order?: SalesOrderDTO) => order && canTransition(order, DeliveryStatus.Accepted);
export const canTransitionToCancel = (order?: SalesOrderDTO) => order && canTransition(order, DeliveryStatus.Rejected);
export const canTransitionToPrepare = (order?: SalesOrderDTO) => order && canTransition(order, DeliveryStatus.Preparing);
export const canTransitionToPrepared = (order?: SalesOrderDTO) => order && canTransition(order, DeliveryStatus.Prepared);
export const canTransitionToDelivering = (order?: SalesOrderDTO) => order && canTransition(order, DeliveryStatus.Delivering);
export const canTransitionToDelivered = (order?: SalesOrderDTO) => order && canTransition(order, DeliveryStatus.Delivered);
export const canClose = (order?: SalesOrderDTO) => order && !order.IsFrozen && order.DeliveryStatus !== DeliveryStatus.Rejected;
export const canReopenOrder = (order?: SalesOrderDTO) => order && order.DeliveryStatus !== DeliveryStatus.Rejected && !order.IsFrozen;
